import { render, staticRenderFns } from "./areaSelect.vue?vue&type=template&id=5762b6e4&scoped=true"
import script from "./areaSelect.vue?vue&type=script&lang=js"
export * from "./areaSelect.vue?vue&type=script&lang=js"
import style0 from "./areaSelect.vue?vue&type=style&index=0&id=5762b6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762b6e4",
  null
  
)

export default component.exports